module.exports = __webpack_public_path__ + "img/ltkplussize-3x.53851ce.jpg";